/**
 * Drawing a video frame onto a canvas, the same way round the operator is seeing it.
 *
 * The webcam preview is mirrored — somebody framing themselves expects a mirror, and moving
 * left has to move the image left. The capture drew the RAW frame, so the photo came back
 * reversed against the thing that had just been framed. Whatever the preview shows, the
 * capture matches it; that is the whole job of this function.
 */

export interface DrawVideoFrameOptions {
  width: number;
  height: number;
  /** True when the preview is mirrored, which is the default for a webcam. */
  mirrored: boolean;
}

export function drawVideoFrame(
  ctx: CanvasRenderingContext2D,
  source: CanvasImageSource,
  { width, height, mirrored }: DrawVideoFrameOptions,
): void {
  // save/restore around the transform: the canvas may be drawn on again, and a transform
  // left in place would silently flip whatever came next.
  ctx.save();
  if (mirrored) {
    // Flip about the vertical centre line — shift right by the full width, then invert x.
    ctx.translate(width, 0);
    ctx.scale(-1, 1);
  }
  ctx.drawImage(source, 0, 0, width, height);
  ctx.restore();
}
